import { DataObject } from '@/utils/DataObject';
import { Account } from './Account';
import { AbsenceTransformer } from './AbsenceTransformer';


export class AccountTransformer {

  private formatDate(date: string) {
    if (date) {
      const d = new Date(date);
      return `${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(
        -2
      )}/${d.getFullYear()}`;
    }
    return "";
  }


  private getTranslation(key: string, data: DataObject = {}): any {
    if (!data.translations) return {};
    return {
      fi: data.translations.fi ? data.translations.fi[key] : null,
      se: data.translations.se ? data.translations.se[key] : null,
      en: data.translations.en ? data.translations.en[key] : null
    };
  }



  public toClass(data: DataObject = {}): Account {
    return new Account({
      evaluationStatus: data.evaluation_status,
      isEvaluable: data.is_evaluable,
      absence: new AbsenceTransformer().toClass(data.absences),
      url: data.url,
      about: this.getTranslation('about', data),
      education: this.getTranslation('education', data),
      memberships: this.getTranslation('memberships', data),
      solo_exhibitions: this.getTranslation('solo_exhibitions', data),
      group_exhibitions: this.getTranslation('group_exhibitions', data),
      grants: this.getTranslation('grants', data),
      residences: this.getTranslation('residences', data),
      collections: this.getTranslation('collections', data),

      is_newsletter_subscribed: data.is_newsletter_subscribed,
      birthday: this.formatDate(data.birthday),
      phone: data.phone,
      bank_iban: data.bank_iban,
      bank_swift: data.bank_swift,
      addressline_1: data.addressline_1,
      city: data.city,
      country: data.country,
      zip: data.zip,
      email: data.email,
      associations: data.associations ? data.associations.map(asc => asc.id) : [],
      professions: data.professions ? data.professions.map(prof => prof.id) : [],
      finnish_artists_assoc: data.finnish_artists_assoc
    })
  }
}
